import { CCol, CRow, CButton } from "@coreui/react";
import { useEffect, useRef, useState } from "react";

import {
  apiCall,
  PG_BASE_URL_PAYMENT,
  PG_WT_CLIENT_CODE,
} from "src/_apiConfig/apiCall";
import Auth from "src/auth";

const Pgtest = () => {
  const [checksum, setchecksum] = useState("");
  const { authenticated } = Auth();
  const formRef = useRef(null);
  const [pgpath, setpgpath] = useState("");

  const approveBG = async () => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Accept", "application/json");

    const responseData = await apiCall(`BG/testpg`, "GET", header, null);
    const jsonobjData = await responseData.json();
    console.log(jsonobjData);
    if (responseData.status === 200) {
      setchecksum(jsonobjData);
      formRef.current.submit();
    }
  };

  useEffect(() => {
    setpgpath(`${PG_BASE_URL_PAYMENT}/ws/payment`);
  }, [authenticated]);

  return (
    <>
      <CRow>
        <CCol xl={6}>
          <strong> txn-id: </strong>LT-EWOH-5aa16c573b804b2eb39de792dd3e45e2--1{" "}
          <br></br>
          <strong>
            {" "}
            txn-session-id:{" "}
          </strong>jZHUoa38VIn4kLwxDawJVAMoHsdJqTqe7hJ <br></br>
          <strong> txn-datetime: </strong>DateTime.Now.ToString("dd/MM/yyyy
          HH:mm:ss", CultureInfo.InvariantCulture)<br></br>
          <strong> txn-amount: </strong>991620 <br></br>
          <strong> txn-for:</strong>Payment <br></br>
          <strong>return-url:</strong>
          https://cgmf.project247.in/api/PaymentResponse <br></br>
          <strong>cancel-url:</strong>
          https://cgmf.project247.in/api/PaymentResponse/PaymentCancel?value=ODI5ODI={" "}
          <br></br>
          <strong>challan-expiry-date:</strong>DateTime.Now.ToString("dd/MM/yyyy
          HH:mm:ss", CultureInfo.InvariantCulture) <br></br>
          <strong> PG_URL: </strong> https://www.b2biz.co.in <br></br> <br></br>
          <strong> PG_CLIENT_CODE :</strong> WT-1265 <br></br> <br></br>
          <strong style={{ verticalAlign: "top" }}>PG_WALLETKEY :</strong>
          <label
            style={{
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              width: "500px",
            }}
          >
            MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCbTRhVIBIvaGa0gDuy1gJEsOm9gekKu+UwwASBTt/qyGd01RWMppcaGWYi4q+ZVwxqFw1ggju4fGUueVqFZNjkwZ6ayvxGs34+k0QfmT4htf4bhl7X9YndHjGzvpvJSJ4o3PJArqItTWmx4xfTzk8MoK1LIhW6QXepxCLOE+anfQIDAQAB
          </label>{" "}
          <br></br> <br></br>
          <strong style={{ verticalAlign: "top" }}>PG_CLIENTKEY :</strong>
          <label
            style={{
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              width: "500px",
            }}
          >
            MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAKHcS8E2pRH2CXjYL4a+soKezwED9blHeCy3DMpxt3LsPAuqluX+87sWn7ERpAvShAdALKmS9cUoSoHmWNFi+1JomMbUnXR5Ausj06Viyesuos/gKu/Od5twd4Ucv1V8u50tIH6NzKRwRUmHNsh8ovI/khpNVytvJZWsEUWbjiptAgMBAAECgYEAgs5Ifl3N6wT9xKZZSjikhMEYo0Zy94fVi7Vm5dgenAZjxD3ZcwemKwTuiyepflBjmIR5U5VLf0i/Zdkk4Bpw5XAgAldQYmVqeOsTtJSUFHCukzYo0CqXKC74UfA9obbdI87Eim+rqt9Ez0jgtf1amwkvpYGXrdHvyPTU9wLd0BUCQQDS5xPT4pV6/eJK+6qN1/R12x080YoqOA989pHZd2RB5GKzHbGQQNd/Wt0Dxu9oXyLSeha1HwRu5+CcQyatfqhTAkEAxHigiX377A8MT1/GjPXnLGJjB9RGOLMr42pJPo5OALt7A8j+w/LoUZVsSaqK5V3lJjEaCl9p06m6bwWbJgKKPwJBAJJVAszhShYsUfb050HDtTqQ7ZhlSxhADX8HFetti4KslE7zK2CLnPogcXlNbo9ccyzWySqietD40j+Z2BxI5UECQQCkIJEbyt8VCE0kUcIwJ4yDC33nIHG5FBRp2nRtibun6PaO5u3NC7L/1G+t6oY1rgarrQEwAR0K8RMJhAlj62NJAkAi4g4p+liTxw/F0rCEJPG2tOqgXN21cVbP9oOzHncGkmbqIZcXnskxibZX9x7f5MvotVtJVaJTBuiDUq4GQA+X{" "}
          </label>{" "}
          <br></br>
          <CButton
            className="mt-5"
            color="success"
            onClick={() => {
              approveBG();
            }}
          >
            Post Data
          </CButton>
        </CCol>
      </CRow>

      {
        <form
          method="post"
          ref={formRef}
          action={pgpath}
          //action="https://demo.b2biz.co.in/ws/payment"
        >
          {/* <input type="hidden" name="walletClientCode" value="WT-1304" /> */}
          <input
            type="hidden"
            name="walletClientCode"
            value={PG_WT_CLIENT_CODE}
          />
          <input type="hidden" name="walletRequestMessage" value={checksum} />
        </form>
      }
    </>
  );
};
export default Pgtest;
